import * as Sentry from '@sentry/nuxt'

const { public: config } = useRuntimeConfig()

if (['prod', 'test'].includes(config.environment)) {
  Sentry.init({
    dsn: config.sentry.dsn,
    release: config.release || 'unknown',
    environment: config.environment,
    tracesSampleRate: 0.1,
    debug: false,
    ignoreErrors: [
      'canceled',
      'Load failed',
      'Failed to fetch',
      'Request aborted',
      'Network Error',
      'NetworkError',
      'Forbidden',
      'Page Not Found',
      'Request failed with status code 403',
      'Non-Error exception captured',
      'Non-Error promise rejection captured',
      'ResizeObserver loop completed with undelivered notifications.',
    ],
    denyUrls: [
      // Chrome extensions
      /extensions\//i,
      /^chrome:\/\//i,
      /^chrome-extension:\/\//i,
    ],
  })
}
